import { PropsWithChildren } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { Dialog } from 'common/components/Dialog';
import { CommunitySuccessIcon } from 'community/components/icons/CommunitySuccessIcon';

interface CommunityCreationSuccessProps {
  isOpen: boolean;
}

export const CommunityCreationSuccess = ({ children, isOpen }: PropsWithChildren<CommunityCreationSuccessProps>) => (
  <Dialog
    isOpen={isOpen}
    maxWidth="sm"
    title="Community Creation Successful"
    showCancelButton={false}
    showCloseButton={false}
    Actions={children}
  >
    <Stack alignItems="center" pt={2}>
      <Box sx={{ width: 112, height: 83 }}>
        <CommunitySuccessIcon />
      </Box>
      <Box pt={4} pb={2} textAlign="center">
        <Typography>You have successfully created a community.</Typography>
        <Typography>Create an Event to get started.</Typography>
      </Box>
    </Stack>
  </Dialog>
);
